export default "__VITE_ASSET__BZqCW5$M__"